export default __webpack_public_path__ + "static/media/jobfinder.6c724735.png";